// Comprehensive list of business categories for advertiser industry verticals
// Special handling: "Movies" requires 60 business-day gap between hold expiration and flight start

export const BUSINESS_CATEGORIES = [
  'Adult',
  'Adult Entertainment',
  'Airlines',
  'Alcohol',
  'Amusement Parks',
  'Associations - Unions',
  'Auto Dealer Associations',
  'Auto Dealers',
  'Auto Insurance',
  'Auto Manufacturers',
  'Auto Rentals',
  'Auto Services',
  'Automotive',
  'Baby Care',
  'Banks - Credit Unions',
  'Beauty - Fragrance Brands',
  'Beauty - Fragrance Retailers',
  'Beer',
  'Beverage Non-alcoholic',
  'Boating',
  'Books - Authors',
  'Broadway Shows',
  'Cable Network',
  'Cannabis',
  'Cannabis Retailers, Brands, Delivery',
  'Casinos',
  'CBD',
  'College - University',
  'Conglomerate',
  'Consumer Electronics',
  'Consumer Packaged Goods',
  'Contractors',
  'Convenience Stores',
  'Credit Cards',
  'Cruise Lines',
  'Cryptocurrency',
  'Day Care - Nursing',
  'Delivery Service',
  'Department Stores',
  'Departments - Agencies',
  'Doctors - Dentists - Clinics',
  'Domestic Airlines',
  'E-Cigarettes',
  'E-Commerce Not fashion',
  'Education',
  'Electricians',
  'Employment - Recruitment',
  'Employment Marketplace',
  'Energy - Utility - Gas Providers',
  'Entertainment',
  'Events',
  'Fashion - Clothing Retailers',
  'Fashion - Fashion Retail',
  'Fast Food - QSR',
  'Financial Not insurance',
  'Fitness - Gyms - Wellness',
  'Food and Beverage',
  'Food Products',
  'Footwear - Sneakers',
  'Funeral Homes - Services',
  'Furniture - Housewares',
  'Gas Stations',
  'Government - Political',
  'Grocery - Market - Deli',
  'Hard Seltzers',
  'Health',
  'Health - Medical',
  'Health Insurance',
  'Home Improvement - Specialty Retail',
  'Home Improvement Services',
  'Home Insurance',
  'Hospitals - Services',
  'Hotel - Accommodations',
  'Household Goods',
  'HVAC',
  'Insurance',
  'International Airlines',
  'Investing - Planning',
  'Jewelry - Watches',
  'Legal Services - Lawyers',
  'Life Insurance',
  'Liquor',
  'Live Entertainment',
  'Local - Network TV',
  'Location-Based Entertainment',
  'Lottery',
  'Luxury Fashion - Retail',
  'Magazines - Newspapers',
  'Mass Market Retailers',
  'Media',
  'Medical',
  'Medical Research',
  'Military Not recruitment',
  'Military Recruitment',
  'Misc. Entertainment',
  'Misc. Service Providers',
  'Mortgage Services',
  'Movies',
  'Moving - Storage',
  'Museums',
  'Musical Events',
  'National TV',
  'Non-Profit',
  'Online Gambling - Betting',
  'OTC Pharmaceutical',
  'Other - Airlines',
  'Other - Alcohol',
  'Other - Automotive',
  'Other - Cannabis',
  'Other - Consumer Packaged Goods',
  'Other - Education',
  'Other - Employment - Recruitment',
  'Other - Entertainment',
  'Other - Fashion',
  'Other - Financial Not insurance',
  'Other - Food and Beverage',
  'Other - Government',
  'Other - Health',
  'Other - Home Improvement Services',
  'Other - Insurance',
  'Other - Live Entertainment',
  'Other - Location-Based Entertainment',
  'Other - Media',
  'Other - Medical',
  'Other - Misc. Service Providers',
  'Other - Non-Profit',
  'Other - Pharmaceutical',
  'Other - Real Estate',
  'Other - Restaurants',
  'Other - Retail',
  'Other - Streaming',
  'Other - Technology',
  'Other - Telecom - Wireless - Internet Providers',
  'Other - Television',
  'Other - Travel',
  'Other - Utilities',
  'Payment Services',
  'Personal Care Not makeup',
  'Pet Care',
  'Pharmaceutical',
  'Plumbing',
  'Political',
  'Prescriptions',
  'Primary - Secondary',
  'Private College - University',
  'PSA - Charities',
  'Psychics - Psychic Readings',
  'Public College - University',
  'Public Transportation',
  'Radio',
  'Real Estate',
  'Real Estate Agents - Agencies',
  'Real Estate Builder - Developer',
  'Real Estate Online Marketplace',
  'Real Estate Rentals',
  'Recorded Music',
  'Recruiters',
  'Religious Organizations',
  'Restaurants',
  'Retail',
  'Ride Share',
  'Salons',
  'Self Promo - Influencer',
  'Shopping Centers - Malls',
  'Sitdown - Club - Bar',
  'Social Media Platforms',
  'Software',
  'Sports Team - Stadiums',
  'Streaming - Audio',
  'Streaming - Video',
  'Streaming Services',
  'Supplemental Education',
  'Tax Services',
  'Technology',
  'Telecom - Internet Providers',
  'Telecom - Wireless - Internet Providers',
  'Television',
  'Theater',
  'Tourism Board',
  'Toys - Games - Hobby Craft',
  'Trade Shows - One Time Events',
  'Transportation Services',
  'Travel',
  'Travel Agents',
  'Utilities',
  'Video Games - Electronic Games',
  'Vision - Eyecare',
  'Wine',
  'Wireless',
  'Zoos',
] as const;

export type BusinessCategory = typeof BUSINESS_CATEGORIES[number] | string;

// Helper function to check if a category requires special handling
export function requiresMoviesGap(category: string): boolean {
  return category === 'Movies';
}

// Helper function to get category suggestions based on input
export function getBusinessCategorySuggestions(input: string): string[] {
  if (!input) return [...BUSINESS_CATEGORIES];
  
  const lowerInput = input.toLowerCase();
  return BUSINESS_CATEGORIES
    .filter(cat => cat.toLowerCase().includes(lowerInput));
}
